export enum QUERY_KEYS {
  eventAttendeesStats = 'event-attendees-stats',
  eventSalesStats = 'event-sales-stats',
  eventReportSalesRecap = 'event-report-sales-recap',
  eventSalesStatsAddons = 'event-sales-stats-addons',
  eventCustomFieldsStats = 'event-sales-custom-fields-stats',
  eventSalesStatsGroupBy = 'event-sales-stats-groupby',
  eventChannelsSalesStats = 'event-channels-sales-stats',
  eventReportExportBookings = 'event-report-export-bookings',
  eventReportExportPreRegistrationBookings = 'event-report-export-pre-registration-bookings',
  eventViewsStats = 'event-views-stats',
  getEventBooking = 'event-booking',
  getEventBookings = 'get-event-bookings',
  getEventPreRegistrations = 'get-event-preregistrations',
}
